import React from "react";
import { Tooltip, createStyles, makeStyles, Theme } from "@material-ui/core";
import { title } from "process";
// import Typography from "material-ui/styles/typography";
// import ReactHtmlParser from "react-html-parser";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headingImage: {
      width: 16,
      height: 16,
      // marginRight: 6,
      objectFit: "contain",
      cursor: "pointer",
      verticalAlign: "top",
      "&:hover": {
        color: "#5e72e4"
      }
    },
    editImage: {
      width: 16,
      height: 16,
      //marginTop: 4,
      //marginRight: 6,
      objectFit: "contain",
      cursor: "pointer",
      "&:hover": {
        color: "#5e72e4"
      }
    },
    editWhiteImage: {
      width: 14,
      height: 14,
      marginTop: 3,
      marginRight: 0,
      objectFit: "contain",
      cursor: "pointer",
      "&:hover": {
        color: "#5e72e4"
      }
    },
    tooltip: {
      color: "#32325d",
      backgroundColor: "white",
      fontFamily: `"Open Sans", sans-serif !important`,
      fontSize: 12,
      boxShadow: "0 2px 12px 0 rgba(50, 50, 93, 0.21)",
      minWidth: "185px",
      maxWidth: "400px",
      padding: "9px"
    },
    arrow: {
      color: "white",
    },
  })
);

export interface iconType {
  clicked?: any, keyDown?: any, topic?: string, nameofClass?: string, infoIconData?: any
}

export const IconTooltip = (props: iconType) => {
  const { clicked, keyDown, topic, nameofClass, infoIconData } = props;
  const cookievalue = "; " + document.cookie;
  const parts = cookievalue.split("; " + "loginFlow" + "=");
  let loginflow;
  if (parts.length === 2) {
    // @ts-ignore
    loginflow = parts.pop().split(";").shift();
  }
  else {
    loginflow = null;
  }
  const isLATUser = loginflow === "LAT" ? true : false;
  const classes = useStyles();
  const iconSrc = require(`../../images/${topic}.svg`)
  // const content = infoIconData?infoIconData.replaceAll('`',''):topic;
  let content = ""
  try {
    content = infoIconData ? infoIconData.replaceAll('`', '') : topic;
  } catch (error) {
    content = topic || "";
  }
  function handleClick(e: any) {
    e.preventDefault();
    return false;
  }
  return (
    <>
      { infoIconData !== undefined ? <Tooltip title={content} classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow
      }}
             placement="right" arrow>
        <img
          className={
            topic === "Edit" ?
              classes.editImage : (topic === "Edit_white" ? classes.editWhiteImage : classes.headingImage)
          }
          src={iconSrc}
          alt={topic}
          style={{
            cursor: "pointer",
            pointerEvents: "all"

          }}
          onClick={handleClick} // DONT COMMENT THIS LINE AS THIS COMPONET IS BEING USED IN MANT PLACES
          onKeyDown={handleClick}
          data-testid={topic}
        />

      </Tooltip> : (topic !== "Information" ?
        <Tooltip title={infoIconData ? infoIconData : topic}>
          <img
            className={
              topic === "Edit" ?
                classes.editImage : (topic === "Edit_white" ? classes.editWhiteImage : classes.headingImage)
            }
            src={iconSrc}
            alt={topic}
            onClick={clicked}    // DONT COMMENT THIS LINE AS THIS COMPONET IS BEING USED IN MANT PLACES
            onKeyDown={keyDown}
            data-testid={topic}
          />

        </Tooltip> : ""
        )
      }
    </>
  );
};
